let apiUrl,pcdUrl,CSMUrl,PFMUrl;

console.log(
  process.env.VUE_APP_API_ENV,123123133
);

let reg = /\S+(?=\/\w+.html)/;
let str = window.location.pathname.match(reg)?.[0];
switch (process.env.VUE_APP_API_ENV) {
    case "development":
    apiUrl = "https://uat.kia.cn/newkia/apiWeb/v1/kia/";
    pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`;
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    break;
    case "uat":
    apiUrl = "https://uat.kia.cn/newkia/apiWeb/v1/kia/";
    pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    break;
    case "production":
    apiUrl = "https://kiacarservice.kia.cn/newkia/apiWeb/v1/kia/";
    // apiUrl = "https://www.kia.cn/ManawellBizAPI/";
    pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    break;
    default:
    apiUrl = "https://uat.kia.cn/newkia/apiWeb/v1/kia/";
    pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`;
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    break;
}

export { apiUrl, pcdUrl,CSMUrl,PFMUrl};
